import generalInspectionReport from "./generalInspectionReport.vue";
export default generalInspectionReport;
